module.exports = __webpack_public_path__ + "static/img/head_img1.1a487cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/coreBusiness/head_img1.png
// module id = VErL
// module chunks = 12